import { observable, selector } from '@poa/state';
import { ACCESS_LEVEL, GRANTED_HOSTS } from '../auth/auth.constants';

export const filteredData = selector(store => {
  const searchText = store.statistics.filters.search;
  const data = store.statistics.data;

  return data.map((table, idx) => {
    let tbody = data[idx].tbody;

    // filter by input text
    if (searchText !== '') {
      tbody = tbody.filter(row => {
        let isMatched = false;

        Object.keys(row).forEach(sectionId => {
          const sectionData = row[sectionId];
          if (!sectionData) {
            return;
          }

          // since we have status: "active" key here
          if (typeof sectionData === 'object') {
            Object.values(sectionData).forEach(cellData => {
              if (!isMatched) {
                const value = cellData.value.toString().toLowerCase();
                const search = searchText.toLowerCase();

                isMatched = value.includes(search);
              }
            });
          }
        });

        return isMatched;
      });
    }

    return { ...table, tbody };
  });
});

export const isAllColumnsSelected = selector(store =>
  store.statistics.selectors.selectedPreset.columnsConfiguration.every(c => c.isSelected)
);

export const selectedPreset = selector(store => {
  const selectedPreset = store.statistics.filters.columnSettings.availablePresets.find(
    preset => preset.id === store.statistics.filters.columnSettings.currentPresetId
  );
  const { columnsConfiguration } = selectedPreset;
  let filteredColumns = columnsConfiguration.slice();

  switch (store.auth.accessLevel) {
    case ACCESS_LEVEL.operator: {
      const availableColumns = ['type', 'from', 'to', 'date', 'amount'];

      filteredColumns = columnsConfiguration.filter(column =>
        availableColumns.includes(column.name)
      );

      break;
    }
    default:
      break;
  }

  switch (store.auth.currentHost) {
    case GRANTED_HOSTS.nc: {
      const availableColumns = [
        'panel_id',
        'type',
        'from',
        'to',
        'date',
        'site',
        'total_credits',
        'our_credits',
        'our_$'
      ];

      filteredColumns = columnsConfiguration.filter(column =>
        availableColumns.includes(column.name)
      );
      break;
    }
    default:
      const availableColumns = ['panel_id', 'type', 'from', 'to', 'date', 'amount'];

      filteredColumns = columnsConfiguration.filter(column =>
        availableColumns.includes(column.name)
      );
      break;
  }

  return observable({ ...selectedPreset, columnsConfiguration: filteredColumns });
});

export const currentPresetColumnsList = selector(store =>
  store.statistics.selectors.selectedPreset.columnsConfiguration.map(column => column.name)
);
